export const BANK_FUNDING_METHODS = [
    'sepa',
    'gbp_bank_transfer',
    'gbp_open_banking_payment',
    'pix_instant_payment',
];
const contracts = {
    sepa: { currency: 'EUR', providerMethod: 'sepa', execution: 'platform_sepa', widgetMethod: null },
    gbp_bank_transfer: {
        currency: 'GBP',
        providerMethod: 'fps',
        execution: 'hosted_checkout',
        widgetMethod: 'gbp_bank_transfer',
    },
    gbp_open_banking_payment: {
        currency: 'GBP',
        providerMethod: 'fps_open_banking',
        execution: 'hosted_checkout',
        widgetMethod: 'gbp_open_banking_payment',
    },
    pix_instant_payment: {
        currency: 'BRL',
        providerMethod: 'pix',
        execution: 'hosted_checkout',
        widgetMethod: 'pix_instant_payment',
    },
};
export function isBankFundingMethod(value) {
    return BANK_FUNDING_METHODS.some((method) => method === value);
}
export function bankFundingContract(method) {
    return isBankFundingMethod(method) ? contracts[method] : null;
}
/** Platform's signed Widget quote chooses the Widget method; UI labels never do. */
export function providerFundingMethod(method) {
    return isBankFundingMethod(method) ? contracts[method].providerMethod : method;
}
